export type Tier = 'gold' | 'silver' | 'bronze' | 'none';

export const scoreToTier = (passRate: number, totalChecks: number): Tier => {
  if (totalChecks === 0) return 'none';
  if (passRate >= 90) return 'gold';
  if (passRate >= 75) return 'silver';
  if (passRate >= 50) return 'bronze';
  return 'none';
};

export const tierLabel: Record<Tier, string> = {
  gold: 'Gold',
  silver: 'Silver',
  bronze: 'Bronze',
  none: 'Sub-Standard',
};

export const tierBackground: Record<Tier, string> = {
  gold: '#d4a017',
  silver: '#c0c0c0',
  bronze: '#cd7f32',
  none: '#6c4a4a',
};
